import { action } from "../common/Action"
import { CaldaieClient } from "../generated";

const service = new CaldaieClient();

class MarcheCaldaieActions {
    @action
    async getAll() {
        return (await service.getMarcheCaldaieList())!;
    };
}
export default new MarcheCaldaieActions();